import Main from "../components/mainSection/Main";
import Sidebar from "../components/sidebar/Sidebar";


export default function Homepage(){
  return(
    <div className="container relative">
      <Sidebar/>
      <Main/>
    </div>
  )};